module.exports = __webpack_public_path__ + "images/category_lp/common/icon-zero-yen_cea5c6439dab1d5738459b2873046f46.png";